import React from 'react'
import Moments from '../../features/student/Moments'
const MomentsPage = () => {
  return <Moments/>
}

export default MomentsPage